/*郵便番号*/
import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from '../molecules/Paragraph';
import { Button } from 'react-bootstrap';

interface Props {
  id: string;
  label: string;
  need?: boolean;
  value: string[];
  handleChangePostCode1?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangePostCode2?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  clickCallback?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  handleBlurPostCode1?: (event: React.FocusEvent<HTMLInputElement>) => void;
  handleBlurPostCode2?: (event: React.FocusEvent<HTMLInputElement>) => void;
  disabled: boolean;
  message?: string;
  help_msg?: string;
}

const Postcode: React.FC<Props> = ({
  id,
  label,
  need,
  value,
  handleChangePostCode1,
  handleChangePostCode2,
  clickCallback,
  handleBlurPostCode1,
  handleBlurPostCode2,
  disabled,
  message,
  help_msg,
}) => {
  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      content={
        disabled ? (
          <Paragraph label={value && value[0] && value[1] ? `${value[0]}-${value[1]}` : ''} />
        ) : (
          <>
            <Row>
              <Col xs={3} className="pr-0">
                <Form.Control
                  type="text"
                  id={`${id}-0`}
                  onChange={handleChangePostCode1}
                  value={value[0] ? value[0] : ''}
                  disabled={disabled}
                  maxLength={3}
                  onBlur={handleBlurPostCode1}
                />
              </Col>
              <Col xs={1} className="d-flex align-items-center justify-content-center">
                －
              </Col>
              <Col xs={3} className="p-0">
                <Form.Control
                  type="text"
                  id={`${id}-1`}
                  onChange={handleChangePostCode2}
                  value={value[1] ? value[1] : ''}
                  disabled={disabled}
                  maxLength={4}
                  onBlur={handleBlurPostCode2}
                />
              </Col>
              <Col xs={4} className="pr-0">
                <Button onClick={clickCallback} disabled={disabled} variant="outline-secondary">
                  検索
                </Button>
              </Col>
            </Row>
            <Messages help_msg={help_msg} valid_msg={message} />
          </>
        )
      }
    />
  );
};

export default Postcode;
